<router-outlet></router-outlet>
<app-update-notification></app-update-notification>
